import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
	createTheme,
	withStyles,
	makeStyles,
	ThemeProvider,
} from '@material-ui/core/styles';
import {
	Avatar,
	Box,
  Container,
  CssBaseline,
  Divider,
  Grid,
	Paper,
  Typography,
} from '@material-ui/core';
import styled from 'styled-components/macro';

import { BRAND_LOGO_URL } from '../constants';

const background = 'radial-gradient(50% 50% at 50% 50%, rgba(242, 247, 255, 0.43) 0%, #A6B6C1 100%)';
const smallBackground = 'radial-gradient(50% 50% at 50% 50%, rgba(242, 247, 255, 0.43) 0%, #A6B6C1 100%)';
const seoulImage = 'https://portofolio-web.s3.ap-northeast-2.amazonaws.com/seoul.jpeg'

const Logo = styled.img.attrs({
	src: `${BRAND_LOGO_URL}`
})`
	width: 5rem;
	height: 4rem;
`;

const useStyles = makeStyles((theme) => ({
	mainBlock: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100vh',
		// background: background
		backgroundImage: `url(${seoulImage})`,
		backgroundSize: 'cover',
		backgroundPosition: 'center center',
		filter: 'opacity(90%)'

	},
	menu: {
		[theme.breakpoints.down("md")]: {
			fontSize: '1.8rem'
		},
		fontSize: '2.75rem',
		textDecorationLine: 'underline',
		color: 'white',
	},
	profileName: {
		[theme.breakpoints.down("md")]: {
			fontSize: '5rem'
		},
		fontWeight: 600,
		fontSize: '6rem',
		textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
		color: 'white'
	}
}));

const PureLink = styled(Link)`
	color: white;
	text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const customTheme = createTheme({
	typography: {
		fontFamily: [
			'Enriqueta', 'serif', '-apple-system', 'BlinkMacSystemFont','"Segoe UI"', 'Roboto', 
		].join(',')
	}
})


function Home(props) {
	const classes = useStyles();

  return (
    <React.Fragment>
			<ThemeProvider theme={customTheme}>
				<Container maxWidth={false} disableGutters={true}>
					<Grid container component='div' className={classes.mainBlock}>
							<Grid container>
								<Grid item md={12} sm={12} xs={12}>
									<Typography className={classes.profileName}>
										Rico Valentino
									</Typography>
								</Grid>
								<Grid md={3} sm={3} lg={3} xl={3} xs={3}></Grid>
								<Grid container md={6} sm={6} alignContent='center' alignContent='center' justifyContent='center' style={{ marginTop: '2rem' }}>
									{/* <Grid item sm={4} xs={12} md={4} component='span' className={classes.menu}>
										<PureLink to='/home'>
											Home
										</PureLink>
									</Grid> */}
									<Grid item sm={4} xs={12} md={4} component='span' className={classes.menu}>
										<PureLink to='/profile'>
											Profile
										</PureLink>
									</Grid>
									<Grid item sm={4} xs={12} md={4} component='span' className={classes.menu}>
										<PureLink to='/contact'>
											Contact
										</PureLink>
									</Grid>
								</Grid>
							</Grid>
					</Grid>
				</Container>
			</ThemeProvider>
    </React.Fragment>
  )
}

export default Home;